<template>
  <div>
    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-icon
          v-if="
            params &&
            params.context &&
            params.context.parentComponent &&
            params.context.parentComponent.permissions &&
            params.context.parentComponent.permissions.add &&
            params.context.parentComponent.tab == 0 &&
            params.data.status == 'Pending'
          "
          color="primary"
          v-on="on"
          v-bind="attrs"
          @click="editItem"
          class="ml-1 mr-2"
        >
          mdi-pencil
        </v-icon>
      </template>
      <span>Edit</span>
    </v-tooltip>

    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-icon
          color="primary"
          v-on="on"
          v-bind="attrs"
          @click="viewDetails"
          class="ml-2 mr-1"
        >
          mdi-eye
        </v-icon>
      </template>
      <span>View</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  methods: {
    editItem() {
      this.params.context.parentComponent.editQuotation(this.params.data.id);
    },
    viewDetails() {
      this.params.context.parentComponent.viewDetails(this.params.data.id);
    },
  },
};
</script>
